<script>
import { envNow as env } from 'yxt-biz-pc/packages/api';

const serialize = function(obj) {
  if (window.URLSearchParams) {
    return new URLSearchParams(obj).toString();
  }
  let str = [];
  for (let p in obj) {
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  }
  return str.join('&');
};

export default {
  name: 'YxtbizUlcd',
  props: {
    tag: {
      type: String,
      default: 'a',
      validator: (s) => {
        return s === 'a' || s === 'span';
      }
    },
    target: {
      type: String,
      default: '_blank'
    },
    // ulcd 完成设计之后的跳转地址
    doneUrl: {
      type: String
    },
    // ulcd 完成设计之后的回调函数
    doneFn: {
      type: Function
    },
    // 指定ulcd的url便于调试或者跨域调用ulcd, 如: https://xx-phx.yunxuetang.com.cn/ulcd/#/index
    url: {
      type: String
    },
    // 微应用编号
    appCode: {
      type: String,
      required: true
    },
    // 项目id
    subjectId: {
      type: String,
      required: true
    },
    // 设计器id
    designerId: {
      type: String,
      required: true
    },
    // query 附加url参数
    query: [Object, String]
  },
  data() {
    return {
      popWindow: null,
      linkId: '__ulcd_link',
      channelKey: '__ulcd_msgchn',
      curChn: null,
      connected: false,
      msgQueue: [],
      env
    };
  },
  computed: {
    appMsgMeta() {
      const { appCode, subjectId, curChn } = this;
      return {
        appCode,
        subjectId,
        msgChn: curChn
      };
    },
    link() {
      let search = `id=${this.subjectId}&designer=${this.designerId}&app=${this.appCode}`;
      if (this.query) {
        search += '&' + (typeof this.query === 'string' ? this.query : serialize(this.query));
      }
      if (this.target === '_blank') {
        search += `&msgchn=${this.curChn}`;
      }
      if (this.doneUrl) {
        const destUrl = encodeURIComponent(this.doneUrl);
        search += `&doneurl=${destUrl}`;
      }
      const url = this.url ? this.url : '/ulcd/#/index';
      const hasSearch = url.indexOf('?') > 1;
      return `${url}${hasSearch ? '&' : '?'}${search}`;
    }
  },
  watch: {
    'connected'(v) {
      v && this.flushQueue();
    }
  },
  methods: {
    goUlcd() {
      if (this.target === '_self') {
        window.location.href = this.link;
        return;
      }
      this.popWindow = window.open(this.link, this.target);
      this.$nextTick(() => {
        if (this.popWindow === null) {
          this.openUrl(this.link, this.linkId);
        }
      });
      // this.sendMessage('msg before connected' + +new Date());
    },
    openUrl(url, id) {
      let a = document.getElementById(id);
      if (a && a.href) {
        return a.click();
      }
      a = document.createElement('a');
      a.setAttribute('href', url);
      a.setAttribute('target', this.target);
      a.setAttribute('id', id);
      a.click();
    },
    listenMessage() {
      window.addEventListener('message', this.onMessage, false);
    },
    stopListenMessage() {
      window.removeEventListener('message', this.onMessage);
    },
    sendMessage(data) {
      if (!this.popWindow) return;
      if (!this.connected) {
        this.msgQueue.push(data);
      } else {
        this.doSend(data);
      }
    },
    flushQueue() {
      if (!this.msgQueue.length) return;
      this.msgQueue.forEach((msg) => {
        this.doSend(msg);
      });
      this.msgQueue.splice(0, this.msgQueue.length);
    },
    doSend(data) {
      data = {
        payload: data,
        ...this.appMsgMeta
      };
      this.popWindow.postMessage(data, '*');
    },
    sendHandshake() {
      this.sendMessage('handshake_reply');
    },
    verifyMessage(event) {
      const origin = event.origin || event.originalEvent.origin;
      const isTrusted = this.env !== 'prod' || (origin === window.location.origin || /yunxuetang\.com|cn/.test(origin));
      if (!isTrusted) return false;
      const { data } = event;
      const { appCode, subjectId, msgChn } = data;
      const isUlcdMsg = appCode === 'ulcd' && String(subjectId) === String(this.subjectId);
      if (!isUlcdMsg) return false;
      const isInChn = String(msgChn) === String(this.curChn);
      return isInChn;
    },
    onMessage(event) {
      if (this.verifyMessage(event)) {
        const { payload } = event.data;
        console.log(payload);
        if (payload === 'handshake') {
          this.connected = true;
          this.sendHandshake();
          return;
        }
        if (payload === 'ulcd_done') {
          (typeof this.doneFn === 'function') && this.doneFn();
        }
        this.$emit('message', payload);
      }
    }
  },
  created() {
    if (!this.$root[this.channelKey]) {
      this.$root[this.channelKey] = 1;
    } else {
      this.$root[this.channelKey]++;
    }
    this.curChn = this.$root[this.channelKey];
  },
  mounted() {
    this.listenMessage();
  },
  beforeDestroy() {
    this.$root[this.channelKey] && (this.$root[this.channelKey] = null);
    this.stopListenMessage();
  },
  render(h) {
    if (this.tag === 'a') {
      return <a href="javascript:;" on-click={this.goUlcd}>{this.$slots.default}</a>;
    } else {
      return <span on-click={this.goUlcd}>{this.$slots.default}</span>;
    }
  }
};
</script>
